<template>
  <div>
    <v-card class="mb-7" flat>
      <v-card-title> Equipamentos Afetados </v-card-title>

      <v-card-text>
        Por favor, identifique os equipamentos afetados

        <br />

        <div class="mt-5">
          <v-card v-if="equipaments.length < 1" outlined color="#f1f1f1">
            <v-card-text class="pa-10">
              <div class="text-center">
                Nenhum equipamento afetado identificado
              </div>
              <div class="text-center mt-4">
                <v-btn
                  @click="handleClickAddEquipament()"
                  :color="insurer.color"
                  small
                  dark
                  text
                  elevation="0"
                >
                  Adicionar
                </v-btn>
              </div>
            </v-card-text>
          </v-card>

          <EquipamentCard
            v-for="equipament in equipaments"
            :key="equipament.id"
            :equipament="equipament"
            @click:remove="handleClickRemoveEquipament(equipament.id)"
          />
        </div>

        <v-list-item
          @click="handleClickAddEquipament()"
          v-if="equipaments.length > 0"
          link
          class="mt-2"
          :style="{ color: insurer.color }"
        >
          <v-list-item-icon>
            <v-icon :color="insurer.color">mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Adicionar equipamento </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-row class="mt-4">
          <v-col>
            <ResumeCard :equipaments="equipaments"></ResumeCard>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-btn
      :disabled="equipaments.length < 1"
      :dark="equipaments.length >= 1"
      :color="insurer.color"
      @click="$emit('continue')"
    >
      Continuar
    </v-btn>

    <create-equipament-dialog
      ref="equipaments"
      @create="handleAddEquipament"
      :insurer="insurer"
    ></create-equipament-dialog>
  </div>
</template>

<script>
import CreateEquipamentDialog from "./CreateEquipamentDialog.vue";
import EquipamentCard from "./ EquipamentCard.vue";
import money from "@/tools/money";
import ResumeCard from "./ResumeCard.vue";

export default {
  mixins: [],

  components: {
    CreateEquipamentDialog,
    EquipamentCard,
    ResumeCard,
  },

  props: {
    insurer: Object,
  },

  data() {
    return {
      money,
      equipaments: [],
    };
  },

  methods: {
    handleClickAddEquipament() {
      this.$refs.equipaments.open();
    },

    handleClickRemoveEquipament(id) {
      this.equipaments = this.equipaments.filter((i) => i.id !== id);

      this.saveProducts();
    },

    handleAddEquipament(equipament) {
      console.log("antes", this.equipaments);
      this.equipaments = this.equipaments.concat({
        ...equipament,
        id: crypto.randomUUID(),
      });
      console.log("depois", this.equipaments);

      this.$nextTick().then(() => {
        this.saveProducts();
      });
    },

    saveProducts() {
      const payload = JSON.stringify(this.equipaments);

      localStorage.setItem("equipaments", payload);
    },

    loadProducts() {
      const payload = localStorage.getItem("equipaments");
      if (!payload) {
        return;
      }

      this.equipaments = JSON.parse(payload);
    },
  },

  computed: {
    totalClaimed() {
      let total = 0;

      this.equipaments.forEach((equipament) => {
        if (!equipament.invoice) {
          return;
        }

        total += Number.parseFloat(equipament.invoice.total_amount);
      });

      return total;
    },
  },

  created() {
    this.loadProducts();
  },
};
</script>
